import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsConfig, DeferLoadingStrategy, I18nModule, provideConfig, UrlModule } from '@spartacus/core';
import { ShimanoProductListComponent } from '../product/shimano-product-list/container/shimano-product-list.component';
import { ProductRefinementComponent } from '../product/shimano-product-list/product-refinement/product-refinement.component';
import { SearchResultsInfoComponent } from './search-results-info/search-results-info.component';
import { SpellingSuggestionComponent } from './spelling-suggestion/spelling-suggestion.component';

@NgModule({
  imports: [CommonModule, I18nModule, RouterModule, UrlModule, SpellingSuggestionComponent, SearchResultsInfoComponent],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        SearchResultsListComponent: {
          component: ShimanoProductListComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
        ProductRefinementComponent: {
          component: ProductRefinementComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
  ],
  exports: [SpellingSuggestionComponent, SearchResultsInfoComponent],
})
export class SearchResultsModule {}
